<template>
  <el-dialog
    class="flow-dialog"
    :title="$t('i18n.0f39f07d4c5a4a38a5c5d6148bf89926')"
    :close-on-click-modal="false"
    append-to-body
    :visible.sync="visible"
  >
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="180px">
      <el-form-item v-for="item in sortData" :label="$t(item.label)" :prop="item.valueKey" :key="item.label">
        <el-input
          v-model="form[item.valueKey]"
          :maxlength="item.maxLength"
          show-word-limit
          class="search-input"
          :placeholder="$t(item.label)"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel(false)">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('131') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { insertOrUpdateGroup } from '@/api/flow'
import { utilCookies } from '@/util/cookies'
const lang = utilCookies.getLanguage()
const sortData = [
  {
    label: 'i18n.dd859a5814ac48059b248c9bce03d6ab',
    valueKey: 'name_th',
    maxLength: '40',
    placeholder: 'i18n.303788e0618a4a6fb7177075c6eaceb5'
  },
  {
    label: 'i18n.00f36898b33540d7897ab2cb411a91fa',
    valueKey: 'name_en',
    maxLength: '40',
    placeholder: 'i18n.0a583ca4f15b4ee686a5ff3895245cf4'
  },
  {
    label: 'i18n.8edda477ccc448fe81272d9e78d4d919',
    valueKey: 'name_zh',
    maxLength: '8',
    placeholder: 'i18n.6673210d73624c7c95f3500c40777e57'
  }
]

export default {
  data() {
    return {
      visible: false,
      form: {},
      loading: false,
      rules: {},
      sortData
      // formComponents: []
    }
  },
  created() {
    // 默认语言必填
    const currentlang = `name_${lang}`
    this.rules[currentlang] = [{ required: true, message: this.$t('90') }]
    // 默认语言排序优先
    const index = sortData.findIndex(item => item.valueKey === currentlang)
    const firstLangItem = sortData.splice(index, 1)[0]
    sortData.unshift(firstLangItem)
  },
  methods: {
    init(params) {
      this.visible = true
      if (params.type === 'edit') {
        this.form = params.data
      }
    },
    // 是否刷新页面
    handleCancel(isUpdate) {
      this.visible = false
      this.$emit('update', isUpdate)
    },
    handleConfirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          insertOrUpdateGroup(this.form)
            .then(res => {
              this.handleCancel(true)
            })
            .finally(() => (this.loading = false))
        }
      })
    }
  }
}
</script>

<style></style>
